import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import AddressContent from '../../../../fragments/address/address-content'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { billingAddress, onAddress } = props
    return <div className={classes.Container}>
        <div className={classes.Hd}><FormattedMessage id="billing_address" defaultMessage={'Billing Address'}/></div>
        <div className={classes.Bd} onClick={e => onAddress(billingAddress)}>
            <AddressContent address={billingAddress}/>
            <Iconfont className={classes.Icon}>
                &#xe690;
            </Iconfont>
        </div>
    </div>
}